import { Component, Input } from "@angular/core";
import { RequestLogEntity } from "../../../entities/log/request-log.entity";

@Component({
  selector: "embed-request-log",
  template: `
    <div class="card p-0 m-0">
      <div class="card-header p-0 m-0">
        <div class="row align-items-center no-gutters">
          <!-- Time and Span -->
          <div class="col-2">
            {{ entity.time | date : "MM/dd/yyyy HH:mm:ss" }} @
            {{ entity.span }}
          </div>

          <!-- Request Category -->
          <div class="col-3">
            {{ entity.request_category }}
          </div>

          <!-- Content (truncate or display switch) -->
          <div class="col-3">
            <div [ngSwitch]="entity.request_category">
              <div *ngSwitchCase="'report_binary'" class="text-truncate">
                [HEX: {{ entity.content?.request_body?.Data }}]
              </div>
              <div *ngSwitchDefault>[Expand For Additional Details]</div>
            </div>
          </div>

          <div class="col-1 text-center">
            <span *ngIf="!isGateway">
              {{ entity.gateway.split(".")[2].split("@")[0] }} -
              {{ entity.gateway.split(".")[2].split("@")[1] }}
            </span>
            <span *ngIf="isGateway">
              {{ entity.device.split(".")[2].split("@")[0] }}
            </span>
          </div>

          <!-- Button -->
          <div class="col-2 text-center">
            <button
              *ngIf="entity.response_code != '0'"
              class="btn btn-sm btn-outline-primary"
              [title]="entity.content?.response_body | json"
            >
              {{
                options?.responseKeyFilter && options?.responseKeyValue
                  ? 'Response - ' + options.responseKeyValue
                  : 'Response'
              }}
            </button>
          </div>

          <!-- Expand/Collapse Icon -->
          <div class="col-1 text-center">
            <i
              (click)="expand = !expand"
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !expand,
                'fa-chevron-up': expand
              }"
              style="cursor: pointer;"
            ></i>
          </div>
        </div>
      </div>

      <div class="card-body" *ngIf="expand">
        <pre><b>Time:</b> {{entity.time}}</pre>
        <pre><b>Response Code:</b> {{entity.response_code}}</pre>
        <pre><b>Request Token:</b> {{entity.request_token}}</pre>
        <pre><b>Span:</b> {{entity.span}}</pre>
        <pre><b>Type:</b> {{entity.request_category}}</pre>
        <pre><b>Endpoint:</b> {{entity.api_endpoint}}</pre>
        <pre><b>Gateway:</b> {{entity.gateway}} </pre>
        <pre><b>Device:</b> {{entity.device}} </pre>
        <pre><b>Request:</b>
              <div><b>URL:</b>{{entity.content?.url}}?{{entity.content?.query}}</div>
              <div><b>Request:</b>{{entity.content?.request_body || entity.content?.body | json}}</div>
              <div><b>Response:</b>{{entity.content?.response_body | json}}</div>
            </pre>
      </div>
    </div>
  `,
})
export class EmbedRequestLogComponent {
  @Input() entity: RequestLogEntity = null;
  @Input() options: any = {};
  @Input() layout: string = null;
  @Input() isGateway: boolean = false;

  public expand = false;
  constructor() {}
}
